import gql from 'graphql-tag';

export default gql`
  mutation ($input: updateHubsWebTourInput!) {
    updateHubsWebTour(input: $input) {
      clientMutationId
      viewer {
        id
        heInstitution
        hubsWebTour {
          campus_media {
            active
            date_to
            date_from
            product_id
            assets {
              title
              order
              caption
              media_type
              media_url
              mediaDisplayUrl
            }
          }
        }
      }
    }
  }
`;
